import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";
import "./styles/GlobalStyles.ts";
import * as Sentry from "@sentry/react";
import Config from "./utils/EnvConfig";

Sentry.init({
  dsn: Config.SENTRY_DSN,
  sendDefaultPii: true,
  environment: Config.APP_ENVIRONMENT ?? "development",
  release: Config.APP_VERSION,
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Failed to find the root element");
}
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
